import AccountOverview from './AccountOverview/AccountOverview';
import AccountSummary from './AccountSummary/AccountSummary';
import CustomerOffer from './CustomerOffer/CustomerOffer';
import './Home.css';
import NextFiveInstallment from './nextFiveInstallment/NextFiveInstallment';
import NoInstallment from './noInstallment/noInstallment';
import QuickActions from './QuickActions/QuickActions';

import Smartlook from '../../utils/smartlook';
import {sendScreenViewNR} from '../../utils/util';
import ContactPopupModal from '../contact/popupModel/contactPopupModel';
import CurrentlyUnavailableCard from '../currently_unavailable_div/CurrentlyUnavailableCard';
import FuturePaymentGraph from '../futurePaymentGraph/futurePaymentGraph';
import NoContract from '../no-contract/NoContract';

import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const Home = (props) => {
  React.useEffect(() => {
    history.pushState(null, null, location.href);
    globalThis.addEventListener('popstate', backButtonHandler);
    return () => globalThis.removeEventListener('popstate', backButtonHandler);
  }, []);

  const backButtonHandler = (e) => {
    e.preventDefault();
  };

  const [visible, setVisible] = React.useState(false);
  const {t} = useTranslation();
  React.useEffect(() => {
    sendScreenViewNR('home');
    Smartlook.navigation('home');
  }, []);
  return (
    <>
      {props.contractNumberError || props.paymentScheduleError ? (
        <div className="unavailable-contracts">
          <CurrentlyUnavailableCard
            title={t('SOMETHING_WENT_WRONG')}
            subTitle={t(
              props.contractNumberError
                ? 'CONTRACT_UNAVAILABLE'
                : 'PAYMENT_SCHEDULE_NOT_AVAILABLE'
            )}
            fullScreen={true}
            handleReload={() => location.reload()}
          />
        </div>
      ) : props.contractNumbers?.contractCounts <= 0 ? (
        <NoContract />
      ) : (
        <>
          <div className="home-username" data-sl="mask">
            {t('WELCOME')} {props.userDetails?.name}
          </div>
          <div className="homeContainer" data-testid="homeContainer">
            <CustomerOffer />
            <AccountSummary />
            <QuickActions />
            <AccountOverview />
            {props.nextInstallment &&
            Object.keys(props.nextInstallment).length === 0 ? (
              <div>
                <NoInstallment
                  icon={'nextInstallment'}
                  title={'NO_UPCOMING_INSTALLMENT_TITLE'}
                  subTitle={'NO_UPCOMING_INSTALLMENT_SUBTITLE'}
                />
                <NoInstallment
                  icon={'nextFiveInstallment'}
                  title={'NO_FUTURE_PAYMENT_TITLE'}
                  subTitle={'NO_FUTURE_PAYMENT_SUBTITLE'}
                />
              </div>
            ) : props.contractNumbers?.contractCounts === 1 ? (
              <NextFiveInstallment
                showAssets={false}
                contractNumber={
                  props.contractNumbers?.contracts[0].contractNumber
                }
              />
            ) : (
              <FuturePaymentGraph
                contractCounts={props.contractNumbers?.contractCounts}
              />
            )}
          </div>
        </>
      )}
      <ContactPopupModal
        id="ContactPopupModal"
        title={''}
        visible={visible}
        setVisible={setVisible}
      />
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    contractNumbers: state.appStates.contractNumbers,
    contractNumberError: state.appStates.contractNumberError,
    userDetails: state.appStates.userDetailsInfo,
    paymentScheduleLoader: state.appStates.paymentScheduleLoader,
    paymentScheduleError: state.appStates.paymentScheduleError,
    nextInstallment:
      state.appStates.paymentSchedule?.paymentSchedules?.nextInstallment,
    countryCode: state.appStates.allContracts?.countryCode,
  };
};
export default connect(mapStateToProps)(Home);
